(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/assets/javascripts/views/fractiongames-page.js') >= 0) return;  svs.modules.push('/modules/lotto/assets/javascripts/views/fractiongames-page.js');

'use strict';

svs.lotto.views.FractiongamesPage = Marionette.View.extend({
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'lotto',
    component: 'fractiongames'
  }],
  template() {
    return svs.lotto.templates.fractiongames_page();
  },
  onDomRefresh() {
    if (svs.lotto.components.fractiongames) {
      const target = document.getElementById('ngFractiongamesRegion');
      target && ReactDOM.render(React.createElement(svs.lotto.components.fractiongames.FractiongamesApp, null), target);
    }
  },
  onDestroy() {
    if (svs.lotto.components.fractiongames) {
      const target = document.getElementById('ngFractiongamesRegion');
      target && ReactDOM.unmountComponentAtNode(target);
    }
  }
});

 })(window);